<template lang="pug">
b-modal#verifactu-notification-modal(
  ref="verifactu-notification-modal"
  :title="$t('login.verifactuNotification.title')"
  :ok-title="$t('login.verifactuNotification.accept')"
  :cancel-title="$t('button.cancel')"
  ok-only
  @ok="handleAccept"
  @hide="handleHide"
  no-close-on-backdrop
  no-close-on-esc
)
  p {{ $t('login.verifactuNotification.message') }}
  p.font-weight-bold {{ $t('login.verifactuNotification.defaultOption') }}
  p(v-html="$t('login.verifactuNotification.instructions')")
  p 
    router-link(to="/ayuda/verifactu" @click.native="$refs['verifactu-notification-modal'].hide()") {{ $t('login.verifactuNotification.link') }}
  
  .mt-3.verifactu-no-show-again
    b-form-checkbox(
      v-model="doNotShowAgain"
      name="do-not-show-again"
    ) {{ $t('login.verifactuNotification.doNotShowAgain') }}
</template>

<script>
const STORAGE_KEY = 'verifactu_notification_dismissed'

export default {
  name: 'VerifactuNotificationModal',
  data () {
    return {
      doNotShowAgain: false
    }
  },
  methods: {
    show () {
      const dismissed = localStorage.getItem(STORAGE_KEY)
      if (!dismissed) {
        this.$refs['verifactu-notification-modal'].show()
      }
    },
    handleAccept () {
      if (this.doNotShowAgain) {
        localStorage.setItem(STORAGE_KEY, 'true')
      }
    },
    handleHide (evt) {
      if (evt.trigger !== 'ok' && this.doNotShowAgain) {
        localStorage.setItem(STORAGE_KEY, 'true')
      }
    }
  }
}
</script>

<style scoped>
.verifactu-no-show-again label {
  width: 285px;
}
</style>
